export default [
    {
        title: '系统管理',
        path: '/system',
        name: 'system',
        meta: {
            key: 'system'
        },
        permission: 'system',
        menu: true,
        children: [
            {
                title: '用户管理',
                path: '/user',
                name: 'user',
                component: () => import('@/views/user/list'),
                meta: {
                    key: 'user',
                    open: 'system'
                },
                permission: 'user',
            },
            {
                title: '管理员',
                path: '/system/admin',
                name: 'systemAdmin',
                component: () => import('@/views/system/admin'),
                meta: {
                    key: 'systemAdmin',
                    open: 'system'
                },
                permission: false,
                permissionCheck: (_personal) => {
                    return _personal.permission == null; //只有超级管理员有权限
                }
            },
            {
                title: '角色权限',
                path: '/system/role',
                name: 'systemRole',
                component: () => import('@/views/system/role'),
                meta: {
                    key: 'systemRole',
                    open: 'system'
                },
                permission: false,
                permissionCheck: (_personal) => {
                    return _personal.permission == null; //只有超级管理员有权限
                }
            },
            {
                title: '报价须知模板',
                path: '/system/quotedPriceRemark',
                name: 'systemQuotedPriceRemark',
                component: () => import('@/views/system/quotedPriceRemark'),
                meta: {
                    key: 'systemQuotedPriceRemark',
                    open: 'system'
                },
                permission: 'systemQuotedPriceRemark'
            },
            {
                title: '首页banner',
                path: '/system/mainBanner',
                name: 'systemMainBanner',
                component: () => import('@/views/system/mainBanner'),
                meta: {
                    key: 'systemMainBanner',
                    open: 'system'
                },
                permission: false,
                permissionCheck: () => {
                    return true;
                }
            },
            {
                title: '缓存管理',
                path: '/system/cache',
                name: 'systemCache',
                component: () => import('@/views/system/cache'),
                meta: {
                    key: 'systemCache',
                    open: 'system'
                },
                permissionCheck: (_personal) => {
                    return _personal.permission == null // 只有超级管理员有权限
                }
            },
            {
                title: '职业管理',
                path: '/system/profession',
                name: 'systemProfession',
                component: () => import('@/views/system/profession'),
                meta: {
                    key: 'systemProfession',
                    open: 'system'
                },
                permission: 'systemProfession',
            },
            {
                title: '版本更新',
                path: '/system/versionUpdate',
                name: 'systemVersionUpdate',
                component: () => import('@/views/system/versionUpdate'),
                meta: {
                    key: 'systemVersionUpdate',
                    open: 'system'
                },
                permission: false,
                permissionCheck: (_personal) => {
                    return _personal.permission == null // 只有超级管理员有权限
                }
            }
        ]
    },
    {
        title: '用户详情',
        path: '/user/info',
        name: 'userInfo',
        component: () => import('@/views/user/info'),
        meta: {
            key: 'user',
            open: 'system'
        },
        menu: false,
        permission: false,
        permissionCheck: (_personal) => {
            return false;
        }
    },
    {
        title: '会员积分明细',
        path: '/vip/user/score_statement',
        name: 'vipUserScoreStatement',
        component: () => import('@/views/vip/score_statement'),
        meta: {
            key: 'vipUser',
            open: 'system'
        },
        menu: false,
        permission: false
    }
];
